export type JobProps = {
  jobName: string;
  description: string;
  time: 'Full Time' | 'Part Time';
  location: 'Gurugram' | 'Jaipur' | 'Kanpur' | 'All Locations' | 'Remote';
  link: string;
};
export type TeamJobsProps = {
  teamName: string;
  jobs: JobProps[];
};
export const jobs: TeamJobsProps[] = [
  {
    teamName: 'Marketing',
    jobs: [
      {
        jobName: 'Business Development Manager',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Gurugram',
        link: 'https://angel.co/l/2xZGN3',
      },
      {
        jobName: 'Business Development Manager',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Jaipur',
        link: 'https://angel.co/l/2xZGN3',
      },
      {
        jobName: 'Business Development Manager',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Kanpur',
        link: 'https://angel.co/l/2xZGN3',
      },
    ],
  },
  {
    teamName: 'Engineering',
    jobs: [
      {
        jobName: 'Full Stack Engineer',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Remote',
        link: 'https://angel.co/l/2xZGSE',
      },
      {
        jobName: 'Full Stack Engineer',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Gurugram',
        link: 'https://angel.co/l/2xZGSE',
      },
      {
        jobName: 'Backend Developer',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Gurugram',
        link: 'https://angel.co/l/2xZHeU',
      },
      {
        jobName: 'Backend Developer',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Remote',
        link: 'https://angel.co/l/2xZHeU',
      },
    ],
  },
  {
    teamName: 'PeopleOps',
    jobs: [
      {
        jobName: 'HR Executive',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Gurugram',
        link: 'https://angel.co/l/2xZHtb',
      },
    ],
  },
  {
    teamName: 'Sales & Underwriting',
    jobs: [
      {
        jobName: 'Sales Manager ',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Gurugram',
        link: 'https://angel.co/l/2xZGPh',
      },
      {
        jobName: 'Sales Manager ',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Jaipur',
        link: 'https://angel.co/l/2xZGPh',
      },
      {
        jobName: 'Sales Manager ',
        description: `We're looking for a mid-level product designer to join our team.`,
        time: 'Full Time',
        location: 'Kanpur',
        link: 'https://angel.co/l/2xZGPh',
      },
    ],
  },
];
